module.exports = __webpack_public_path__ + "img/img151_5.2ebd417f.png";